<script lang="ts">
  import { onDestroy } from 'svelte';
  import { searching, cancelSearching } from '../../stores/lobby';

  const TIMEOUT_SEC = 30;

  // Tick local pra atualizar contador. Para quando modal fecha.
  let elapsed = $state(0);
  let intervalId: number | null = null;

  $effect(() => {
    if ($searching.active) {
      elapsed = 0;
      intervalId = window.setInterval(() => {
        elapsed = ($searching.startedAt ? (Date.now() - $searching.startedAt) / 1000 : 0);
      }, 300);
    } else if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
    return () => {
      if (intervalId !== null) clearInterval(intervalId);
    };
  });

  onDestroy(() => {
    if (intervalId !== null) clearInterval(intervalId);
  });

  let remaining = $derived(Math.max(0, TIMEOUT_SEC - elapsed));
  let pct = $derived((remaining / TIMEOUT_SEC) * 100);
  let secsLeft = $derived(Math.ceil(remaining));
  let sub = $derived(
    $searching.matchFound
      ? 'oponente encontrado! entrando na mesa…'
      : 'conexão estabelecida'
  );
  let tier = $derived(
    $searching.queue
      ? `${$searching.queue.label || 'mesa'} · ${$searching.queue.modality}`
      : ''
  );
</script>

{#if $searching.active}
  <div class="searching-overlay">
    <div class="card">
      <div class="orb">
        <div class="orb-ring"></div>
        <div class="orb-ring r2"></div>
        <span class="orb-glyph">◆</span>
      </div>

      <p class="eyebrow">::: localizando adversário</p>
      <h2 class="headline">PROCURANDO MESA</h2>
      <p class="tier">{tier}</p>
      <p class="sub">{sub}</p>

      <div class="bar">
        <div class="bar-fill" style="width: {pct}%"></div>
      </div>
      <div class="countdown">
        <span class="secs">{secsLeft}</span><span class="unit">s</span>
      </div>

      <button class="cancel-btn" onclick={cancelSearching}>
        cancelar
      </button>
    </div>
  </div>
{/if}

<style>
  .searching-overlay {
    position: fixed;
    inset: 0;
    z-index: 900;
    display: grid;
    place-items: center;
    padding: 24px;
    background: rgba(2, 3, 26, 0.85);
    backdrop-filter: blur(8px);
    animation: fade-in .25s ease-out;
  }

  @keyframes fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .card {
    width: 100%;
    max-width: 340px;
    padding: 24px 22px;
    background: linear-gradient(180deg, var(--bg-elev), rgba(2, 3, 26, 0.95));
    border: 1px solid rgba(216, 80, 240, 0.4);
    border-radius: var(--radius-lg);
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.6), 0 0 32px rgba(216, 80, 240, 0.2);
    text-align: center;
    animation: slide-up .3s cubic-bezier(.2, .9, .3, 1.2);
  }

  @keyframes slide-up {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }

  .orb {
    position: relative;
    width: 80px;
    height: 80px;
    margin: 0 auto 18px;
  }
  .orb-ring, .orb-ring.r2 {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    border: 2px solid var(--accent);
    opacity: 0.4;
    animation: orb-pulse 1.8s ease-out infinite;
  }
  .orb-ring.r2 { animation-delay: 0.6s; }
  @keyframes orb-pulse {
    0% { transform: scale(0.6); opacity: 0.8; }
    100% { transform: scale(1.5); opacity: 0; }
  }
  .orb-glyph {
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
    font-size: 28px;
    color: var(--ok);
    text-shadow: 0 0 20px rgba(108, 255, 189, 0.7);
  }

  .eyebrow {
    color: var(--text-dim);
    font-size: 10px;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin: 0 0 6px;
  }
  .headline {
    margin: 0 0 8px;
    font-size: 18px;
    letter-spacing: 2px;
    color: var(--text);
  }
  .tier {
    margin: 0 0 12px;
    color: var(--accent);
    font-size: 12px;
    letter-spacing: 1px;
  }
  .sub {
    margin: 0 0 18px;
    color: var(--text-dim);
    font-size: 13px;
  }

  .bar {
    height: 4px;
    background: var(--surface);
    border-radius: 2px;
    overflow: hidden;
    margin-bottom: 8px;
  }
  .bar-fill {
    height: 100%;
    background: linear-gradient(90deg, var(--ok), var(--accent));
    transition: width .3s linear;
  }
  .countdown {
    font-family: ui-monospace, monospace;
    font-size: 12px;
    color: var(--text-dim);
    margin-bottom: 18px;
  }
  .countdown .secs { color: var(--text); font-weight: 700; }
  .countdown .unit { margin-left: 2px; }

  .cancel-btn {
    width: 100%;
    background: transparent;
    color: var(--danger);
    border-color: rgba(255, 76, 126, 0.3);
  }
  .cancel-btn:hover:not(:disabled) {
    background: rgba(255, 76, 126, 0.08);
    border-color: rgba(255, 76, 126, 0.6);
  }
</style>
